import React from 'react';
import IcmLogo from '../images/product-logos/icm-logo.svg';
import InteliusLogo from '../images/product-logos/intelius-logo.svg';
import TruthfinderLogo from '../images/product-logos/truthfinder-logo.svg';
import UsSearchLogo from '../images/product-logos/ussearch-logo.svg';

type Props = {
	headingTitle: string;
	headingSubTitle: string;
	aboutCopy: string;
	customerCare?: boolean;
};

const About = ({ headingTitle, headingSubTitle, aboutCopy, customerCare }: Props) => (
	<div id="about" className="about blue">
		<div className="container-1200">
			<div className="top-copy">
				<div className="heading">
					<p>{headingTitle}</p>
					<h3>{headingSubTitle}</h3>
				</div>
				<div>
					<h4>{aboutCopy}</h4>
				</div>
			</div>
			{customerCare && (
				<div className="bottom-copy">
					<ul>
						<li>
							<p>Customers we serve:</p>
						</li>
						<li>
							<img src={TruthfinderLogo} alt="truthfinder" />
						</li>
						<li>
							<img src={InteliusLogo} alt="intelius" />
						</li>
						<li>
							<img src={IcmLogo} alt="instant checkmate" />
						</li>
						<li>
							<img src={UsSearchLogo} alt="ussearch" />
						</li>
					</ul>
				</div>
			)}
		</div>
	</div>
);

export default About;
